var map = {
	"./locale-provider/bg_BG.tsx": 800,
	"./locale-provider/ca_ES.tsx": 801,
	"./locale-provider/cs_CZ.tsx": 802,
	"./locale-provider/de_DE.tsx": 803,
	"./locale-provider/en_GB.tsx": 804,
	"./locale-provider/en_US.tsx": 805,
	"./locale-provider/es_ES.tsx": 806,
	"./locale-provider/et_EE.tsx": 807,
	"./locale-provider/fi_FI.tsx": 808,
	"./locale-provider/fr_BE.tsx": 809,
	"./locale-provider/fr_FR.tsx": 810,
	"./locale-provider/it_IT.tsx": 811,
	"./locale-provider/ja_JP.tsx": 812,
	"./locale-provider/ko_KR.tsx": 813,
	"./locale-provider/nl_BE.tsx": 814,
	"./locale-provider/nl_NL.tsx": 815,
	"./locale-provider/pl_PL.tsx": 816,
	"./locale-provider/pt_BR.tsx": 817,
	"./locale-provider/ru_RU.tsx": 818,
	"./locale-provider/sk_SK.tsx": 819,
	"./locale-provider/sv_SE.tsx": 821,
	"./locale-provider/tr_TR.tsx": 822,
	"./locale-provider/vi_VN.tsx": 823,
	"./locale-provider/zh_TW.tsx": 824
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 756;



//////////////////
// WEBPACK FOOTER
// ./components ^\.\/locale-provider\/.+_.+\.tsx$
// module id = 756
// module chunks = 0